





















































import { Component, Vue, Prop } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import Menu from "@/components/Menu.vue";
import Carousel from "@/components/Carousel/Carousel.vue";
import Slide from "@/components/Carousel/Slide.vue";
import NextPrevBtn from "@/components/NextPrevBtn.vue";
import Footer from "@/components/Footer.vue";
@Component({
  components: {
    Carousel,
    Slide,
    Header,
    Menu,
    NextPrevBtn,
    Footer,
  },
})
export default class CVGoFurther extends Vue {
  protected clicked = "";
  protected bool = false;
  protected nbCarousel = 0;
  //tableaux stockage des images des carousels
  protected galeryCover: string[] = [
    "/picture_cv/gofurther_CV/cv-original-burger1.jpg",
    "/picture_cv/gofurther_CV/cv-original-lego.jpg",
    "/picture_cv/gofurther_CV/cv-original-magazine.jpg",
    "/picture_cv/gofurther_CV/cv-original-packagin1.jpg",
  ];
  protected galerySlide1: string[] = [
    "/picture_cv/gofurther_CV/cv-original-burger1.jpg",
    "/picture_cv/gofurther_CV/cv-original-burger2.jpg",
    "/picture_cv/gofurther_CV/cv-original-burger3.jpg",
    "/picture_cv/gofurther_CV/cv-original-burger4.jpg",
  ];
  protected galerySlide2: string[] = [
    "/picture_cv/gofurther_CV/cv-original-lego.jpg",
    "/picture_cv/gofurther_CV/cv-original-lego1.jpg",
  ];
  protected galerySlide3: string[] = [
    "/picture_cv/gofurther_CV/cv-original-magazine.jpg",
    "/picture_cv/gofurther_CV/cv-original-magazine1.jpg",
    "/picture_cv/gofurther_CV/cv-original-magazine2.jpg",
    "/picture_cv/gofurther_CV/cv-original-magazine3.jpg",
    "/picture_cv/gofurther_CV/cv-original-magazine4.jpg",
    "/picture_cv/gofurther_CV/cv-original-magazine5.jpg",
    "/picture_cv/gofurther_CV/cv-original-magazine6.jpg",
    "/picture_cv/gofurther_CV/cv-original-magazine7.jpg",
    "/picture_cv/gofurther_CV/cv-original-magazine8.jpg",
    "/picture_cv/gofurther_CV/cv-original-magazine9.jpg",
  ];
  protected galerySlide4: string[] = [
    "/picture_cv/gofurther_CV/cv-original-packagin1.jpg",
    "/picture_cv/gofurther_CV/cv-original-packagin2.jpg",
  ];
  //tableau de stockage des carousel
  protected galeryCarousel: string[][] = [
    this.galerySlide1,
    this.galerySlide2,
    this.galerySlide3,
    this.galerySlide4,
  ];
  protected display(srcImg: string): void {
    this.nbCarousel = this.galeryCover.indexOf(srcImg);
    if (this.bool == false) {
      this.clicked = srcImg;
      this.bool = true;
      this.$router.push('');
      this.$router.push('#CarouselScroll');
    } else if (this.clicked == srcImg) {
      this.clicked = "";
      this.bool = false;
      
    } else {
      this.clicked = srcImg;
    }
  }
  protected nxtprevCVGoFurther =
  {
    BoolPrev: true,
    BoolNext: false,
    PrevImage: "/thumbnail4.png",
    NextImage: " ",
    PrevLink: "/CV/CV_Video",
    NextLink: " ",
  };
}
